$(document).on('click', '.announcement-bar', function(){
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'UuwQGe']);
});

if($(".featured-product-slider").length > 0) {
  $(".featured-product-slider").slick({
    infinite: true,
    dots: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
}
$(document).on("click", ".featured-slick-nav .slick-prev", function(){
  $(".featured-product-slider").slick("prev");
});
$(document).on("click", ".featured-slick-nav .slick-next", function(){
  $(".featured-product-slider").slick("next");
});

if($(".slideshow.product__media-list").length > 0) {
  $(".slideshow.product__media-list").slick({
    infinite: true,
    dots: false,
    arrows: false,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          dots: true
        }
      }
    ]
  });
}
/*if($(".brand-logo-wrap").length > 0) {
  let logoCount = $(".brand-logo-wrap .logo-item").length;
  $(".brand-logo-wrap").slick({
    infinite: false,
    dots: false,
    arrows: false,
    autoplay: false,
    slidesToShow: logoCount,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });
}*/

if($(".announcement--slider").length > 0) {
  $(".announcement--slider").slick({
    infinite: false,
    dots: false,
    arrows: false,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          infinite: true,
          autoplay: true,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1001,
        settings: {
          infinite: true,
          autoplay: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}


$(document).on("click", ".close-menu-drawer", function(){
  $(".header__icon--menu").trigger("click");
});
$(document).on("click", ".faq-question", function(){
  $(".faq-answer").stop().slideUp();
  $(".faq-question").not($(this)).removeClass("active");
  $(this).next(".faq-answer").stop().slideToggle();
  $(this).stop().toggleClass("active");
});
$(document).on("change", ".faq-checkbox", function(){
  if($(this).is(":checked")) {
  $(".faq-checkbox").not($(this)).prop("checked", false);
    let target = $(this).attr("id");
    let calcTop = $("[data-id='"+target+"']").offset().top - 150;
    $("html, body").animate({
      scrollTop: calcTop+"px"
    });
  }
});

$(document).on("click", ".sc-heading", function(){
  let target = $(this).data("toggle");
  $(this).parent().children(".sc-heading").removeClass("active");
  $(this).addClass("active");
  $(this).parent().parent().parent().find(".scroller-text").hide();
  $(this).parent().parent().parent().find(".scroller-text[data-target='"+target+"']").show();
});

$(function(){
  var $container = $('.text-scroller');
  var $column = $container.find('.sc-heading').first();
  var columnWidth = $column.outerWidth(true); // includes margin
  $(".scroller-wrap").each(function(){
    let btnLeft = $(this).find(".scroll-left");
    let btnRight = $(this).find(".scroll-right");
    let $container = $(this).find('.text-scroller');
    let $column = $container.find('.sc-heading').first();
    let columnWidth = $column.outerWidth(true);
    btnLeft.on("click", function(){
      $container.animate({
        scrollLeft: $container.scrollLeft() - columnWidth
      }, 50);
    });
    btnRight.on("click", function(){
      $container.animate({
        scrollLeft: $container.scrollLeft() + columnWidth
      }, 50);
    });
  });
  
    /*$('#scroll-left').click(function() {
    $container.animate({
      scrollLeft: $container.scrollLeft() - columnWidth
    }, 300);
  });

  $('#scroll-right').click(function() {
    $container.animate({
      scrollLeft: $container.scrollLeft() + columnWidth
    }, 300);
  });*/
  if($(".icons-wrapper").length > 0) {
    let iconCount = $(".icons-wrapper .product-icon").length;
    $(".icons-wrapper").slick({
      infinite: false,
      dots: false,
      arrows: false,
      slidesToShow: iconCount,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    });
    $(document).on("click", ".icons-slick-nav .slick-prev", function(){
      $(".icons-wrapper").slick("prev");
    });
    $(document).on("click", ".icons-slick-nav .slick-next", function(){
      $(".icons-wrapper").slick("next");
    });
  }
  food_vertical_text_position();
  music_mobile_curve_text_position();
});
$(window).on("load resize", function(){
  if($(window).width() <= 749 ) {
    food_vertical_text_position();
    music_mobile_curve_text_position();
  }
});
$(window).on("load", function(){
  var wow = new WOW({
    offset: 250
  });
  wow.init();
});
function food_vertical_text_position() {
  if($(".food-initiative-01").length > 0) {
    var fromTop = $(".food-initiative-01 .num-icon").height() + $(".food-initiative-01 .num-icon").offset().top;
    var fromTop2 = $(".food-initiative-02 .num-icon").offset().top;
    var fromDistance = (fromTop2 - fromTop) - 200;
    console.log(fromDistance);
    $(".vertical-sticky-text").css({"height": fromDistance+"px"});
  }
}

function music_mobile_curve_text_position() {
  if($(".calculate-vertical").length > 0) {
    let fromTop = $(".calculate-vertical").offset().top;
    $(".vertical-side-image.hide-on-desktop").css({"top":(fromTop - 20)+"px"});
  }
}


const customCursor = document.querySelector('.custom-cursor');

// Handle mouse movement
document.addEventListener('mousemove', (e) => {
  customCursor.style.left = `${e.pageX - 39}px`; // Adjust for cursor center
  customCursor.style.top = `${e.pageY - 33}px`;  
});

//$(document).on('mouseenter', 'a, button, summary', function(){
$(document).on('mouseenter', 'img, .banner, .custom_card_inner', function(){
  $('.custom-cursor').addClass("hovering");
});
//$(document).on('mouseleave', 'a, button, summary', function(){
$(document).on('mouseleave', 'img, .banner, .custom_card_inner', function(){
  $('.custom-cursor').removeClass("hovering");
});

// Handle smooth scrolling effect
let lastScrollY = window.scrollY; // Keep track of the last scroll position

window.addEventListener('scroll', () => {
    const scrollDiff = window.scrollY - lastScrollY; // Calculate the scroll difference
    const currentTop = parseFloat(customCursor.style.top || 0); // Get the current top position
    customCursor.style.top = `${currentTop + scrollDiff}px`; // Update the cursor position
    lastScrollY = window.scrollY; // Update the last scroll position
});